import { computed, observable, runInAction } from "mobx";
import * as moment from "moment";
import { api } from "../../api";
import { api_adm } from "../../api";
import { ICalc, ICalcVar, IConta } from "../../model";
import { sortBy } from "../../utils";
import { LookupStore } from "../LookupStore";
import { toast } from "react-toastify";

class _CalcRSStore {

  obs = observable({
    calcs: [] as ICalc[],
    itens_classificacao: [] as any,
    calcs_index: [] as ICalc[],
    contas: [] as any,
    filter: "" as string,
    tipo: "entrada" as string,
    filterText: "" as string,
    sub_tipo: "simples_nacional" as string,
    tab_codigos: "origem" as string,
    calcs_class: [] as ICalc[]
  })


  async load() {

    let resp = await api.get("/api/calcs-rs")

    this.obs.calcs = [];

    const updatedCalcs = resp.data?.map((calc: ICalc) => ({
      ...calc,
      icms_classificacao: LookupStore.getIcmsClassificacao(calc.icms_classificacao_id),
    }));

    this.obs.calcs = [...this.obs.calcs, ...updatedCalcs];

  }

  async get(id: string, tipo: string): Promise<ICalc> {
    let params = {
      id: id,
      tipo: tipo
    }
    let resp = await api_adm.post(`/api/admin/calcs-rs/show`, params);

    return resp.data;
  }

  async handleSave(calc: ICalc) {

    if (calc.id) {

      return this.handleUpdate(calc)

    }

    return this.handleCreate(calc)

  }

  async handleUpdate(calc: ICalc) {

    try {

      let resp = await api_adm.put(`/api/admin/calcs-rs/${calc.id}`, calc);

      if (resp.data.ok) {

        toast.success('Cálculo salvo com sucesso', {});

        return true

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (e) {

      toast.error("Erro ao salvar Cálculo!", {});

    }

    return false

  }

  async handleCreate(calc: ICalc) {

    try {

      let resp = await api_adm.post("/api/admin/calcs-rs", calc);


      if (resp.data.ok) {

        toast.success('Cálculo criado com sucesso', {});

        return true

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (e) {

      toast.error("Erro ao criar Cálculo!", {});

    }

    return false

  }

  reorderVars(calc: ICalc) {
    for (let i = 0; i < calc.vars.length; i++) {
      calc.vars[i].order = i + 1;
    }
  }

  moveVarUp(calc: ICalc, _var: ICalcVar) {
    if (_var.order == 1) return;
    calc.vars.splice(_var.order - 1, 1);
    calc.vars.splice(_var.order - 2, 0, _var);
    this.reorderVars(calc);
  }

  moveVarDown(calc: ICalc, _var: ICalcVar) {
    if (_var.order == calc.vars.length) return;
    calc.vars.splice(_var.order - 1, 1);
    calc.vars.splice(_var.order, 0, _var);
    this.reorderVars(calc);
  }

  deleteVar(calc: ICalc, _var: ICalcVar) {
    calc.vars.splice(_var.order - 1, 1);
    this.reorderVars(calc);
  }

  appendVar(calc: ICalc, _var: ICalcVar) {
    calc.vars.push(_var);
    this.reorderVars(calc);
  }

  reorderVarsFcp(calc: ICalc) {
    for (let i = 0; i < calc.vars_fcp.length; i++) {
      calc.vars_fcp[i].order = i + 1;
    }
  }

  moveVarUpFcp(calc: ICalc, _var: ICalcVar) {
    if (_var.order == 1) return;
    calc.vars_fcp.splice(_var.order - 1, 1);
    calc.vars_fcp.splice(_var.order - 2, 0, _var);
    this.reorderVarsFcp(calc);
  }

  moveVarDownFcp(calc: ICalc, _var: ICalcVar) {
    if (_var.order == calc.vars_fcp.length) return;
    calc.vars_fcp.splice(_var.order - 1, 1);
    calc.vars_fcp.splice(_var.order, 0, _var);
    this.reorderVarsFcp(calc);
  }

  deleteVarFcp(calc: ICalc, _var: ICalcVar) {
    calc.vars_fcp.splice(_var.order - 1, 1);
    this.reorderVarsFcp(calc);
  }

  appendVarFcp(calc: ICalc, _var: ICalcVar) {
    calc.vars_fcp.push(_var);
    this.reorderVarsFcp(calc);
  }

  validForDate(): ICalc[] {
    let date = moment(new Date()).format()

    return this.sorted.filter(calc => {
      if (calc.valido_de == null && calc.valido_ate == null) {
        return true;
      }

      if (date >= moment(calc.valido_de).format() && date <= moment(calc.valido_ate).format()) {
        return true;
      }

      if (calc.valido_de == null && date <= moment(calc.valido_ate).format()) {
        return true;
      }

      if (date >= moment(calc.valido_de).format() && calc.valido_ate == null) {
        return true;
      }

      return false;
    });
  }

  validForDateRetro(): ICalc[] {
    let date = moment(new Date()).format()

    return this.sorted.filter(calc => {
      if (calc.valido_de == null && date >= moment(calc.valido_ate).format()) {
        return true;
      }
      if (moment(calc.valido_de).format() <= date && date >= moment(calc.valido_ate).format()) {
        return true;
      }
      return false
    });
  }

  @computed
  get sorted(): ICalc[] {
    return sortBy(this.obs.calcs, "nome");
  }

  async exportProdutos(calc_id: any) {
    try {
      let resp = await api_adm.post("/api/admin/calcs-produtos/export", { "id": calc_id, estado: "RS" });

      if (resp.data.ok) {
        const linkSource = `data:application/csv;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "export_produtos.csv";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        toast.warning('Não foram encontrados resultados.', {});
      }
    } catch (ex) {
      toast.error("Erro ao exportar Produtos, tente novamente mais tarde.", {});
    }
  }

  async handleCalcFiltered(tipo, text, vigencia) {
    try {
      let params = {
        tipo: tipo,
        vigencia: vigencia,
        filter: text
      }

      let resp = await api_adm.post("/api/admin/calcs-rs/filtered", params);
      this.obs.calcs_index = [];
      resp.data?.forEach((calc: ICalc) => {
        calc.icms_classificacao = LookupStore.getIcmsClassificacao(calc.icms_classificacao_id);
        this.obs.calcs_index.push(calc);
      });
    } catch (ex) {
      toast.error('Erro filtrar Cálculos, tente novamente mais tarde.', {});
    }
  }

  async handldeBuscaClassificacao() {
    this.obs.itens_classificacao = [];

    let params = {
      estado: "RS"
    }
    try {
      let resp = await api.post("/api/icms_classificacoes", params);

      this.obs.itens_classificacao = resp.data.itens
    } catch (ex) { }
  }

  async loadContas() {

    let resp = await api_adm.get("/api/admin/calc-contas")

    this.obs.contas = resp.data;

  }

  get filtered() {

    let filtered = this.obs.contas.filter(c => {
      return c.nome.toUpperCase().indexOf(this.obs.filter.toUpperCase()) != -1;
    });

    return sortBy(filtered, "inserted_at");
  }

  async createClassificacao(params) {

    try {

      let resp = await api_adm.post("/api/admin/icms_classificacoes/create", params);

      if (resp.data.ok) {

        toast.success('Classificação salva com sucesso!', {});
        return true

      } else {

        toast.error(`Não foi possível salvar Classificação: ${resp.data.msg}`, {});

      }

    } catch (ex) {

      toast.error(`Erro ao salvar Classificação!`, {});

    }

    return false

  }

  async updateClassificacao(params) {

    try {

      let resp = await api_adm.post("/api/admin/icms_classificacoes/update", params);

      if (resp.data.ok) {

        toast.success('Classificação salva com sucesso!', {});
        return true

      } else {

        toast.error(`Não foi possível salvar Classificação: ${resp.data.msg}`, {});

      }

    } catch (ex) {

      toast.error(`Erro ao salvar Classificação!`, {});

    }

    return false

  }

}

export const CalcRSStore = new _CalcRSStore();